import React, { useEffect } from 'react';
import get from 'lodash/get';
import DurationInput from 'components/v2/DurationInput/DurationInput';
import { Controller, useFormContext } from 'react-hook-form';
import { AdapterProps } from '../types';
import InputLabel from '../../InputLabel/InputLabel';
import FormControl from 'components/v2/FormControl/FormControl';
import { useFormError } from '../utils';
import mergeRefs from '../../../../utils/merge-refs';
import scheduleMicrotask from '../../../../utils/schedule-microtask';

export type TextAdapterProps = AdapterProps['duration'] &
  React.ComponentProps<typeof DurationInput>;

const DurationAdapter = React.forwardRef((props: TextAdapterProps, ref) => {
  const { label, name, rules, autoFocus, ...rest } = props;
  const { formState, control, setValue } = useFormContext();
  const error = useFormError(get(formState.errors, name));
  const defaultValue = get(formState.defaultValues, name);
  const inputRef = React.useRef<HTMLInputElement>();

  useEffect(() => {
    scheduleMicrotask(() => {
      if (autoFocus && inputRef.current) {
        inputRef.current.focus();
      }
    });
  }, [autoFocus]);

  return (
    <FormControl defaultValue={defaultValue}>
      {label && <InputLabel>{label}</InputLabel>}
      <Controller
        rules={rules}
        render={({ field: { value, ...field } }) => (
          <DurationInput
            {...rest}
            value={value}
            onChange={field.onChange}
            ref={mergeRefs(ref, field.ref, inputRef)}
            autoFocus={autoFocus}
          />
        )}
        name={name}
      />
    </FormControl>
  );
});

export default DurationAdapter;
